import React from 'react';
import { useNavigate } from 'react-router-dom';

const AddSeasonButton = ({ onClick }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate('/movie-box/add-season');
        }
    };

    return (
        <div
            className="border border-gray-200 rounded-2xl p-4 cursor-pointer shadow-sm hover:shadow-md transition-shadow"
            onClick={handleClick}
        >
            <div
                className="border border-gray-200 rounded-2xl flex justify-center p-4 w-full"
            >
                <div className="flex items-center w-fit ">
                    <span className="text-blue-600 mr-2 text-xl">+</span>
                    <span className="text-blue-600 font-medium">Add season</span>
                </div>
           
            </div>
        </div>
    );
};

export default AddSeasonButton;